import { render } from "./QualityCheckForm.vue?vue&type=template&id=64b7dfe2"
import script from "./QualityCheckForm.vue?vue&type=script&lang=js"
export * from "./QualityCheckForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__